import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import Vue from 'vue'

const state = {
  students: []
}

const actions = {
  getGameUserById({commit}, id){
    http.getGameUserById(id)
      .then(res => {
        commit(types.SET_STUDENTS, res.data);
      });
  }
}

const getters = {
  // getStudents: state => state.students,
  // getClassId: state => state.classId,
  // getCClazz:state =>{
  //   return JSON.parse(sessionStorage.getItem('cClazz'))||{}
  // }
}

const mutations = {
  [types.SET_STUDENTS](state, students) {
    Vue.set(state, 'students', students);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/gameUser.js